/**
* reducers for the fund
*
* Created by Paul on 7/5/19
*/

import C from '../constants'
import { isEmpty } from '../utility/utilities'

const initState = {
    data: {
        fund_type: 'Individual',
        members: [
            {
                'not_use_residential_as_mailing': true,
                'occupationOptions': [],
            },
            {
                'occupationOptions': [],
            },
        ]
    },
    fundSummary: {},
    fundInfoData: {},
    membersTrusteesInfoData: [],
    companyDetailsData: {},
    isLoading: true,
    isFundPositionLoading: false,
    fundPosition: 0,
    fundAssetSummary: [],
    isFundDetailedAssetPositionLoading: false,
    fundDetailedAssetPosition: [],
    isFundCashReconciliationLoading: false,
    fundCashReconciliationData: [],
    isFundContributionsLoading: false,
    fundContributionsData: {},
    isSubmitting: false,
    activeStep: -1,
    fundStatus: undefined,
}

export const fundState = (state = initState, action) => {

    switch(action.type) {
        case C.SET_FUND_SUMMARY_DATA:
            return {
                ...state,
                fundSummary: action.payload
            }

        case C.SET_CREATE_FUND_FORM:

            const fundData = {
                'id': action.payload['member']['id'],
                'first_name': action.payload['member']['first_name'],
                'last_name': action.payload['member']['last_name'],
                'email': action.payload['member']['email'],
                'phone': action.payload['member']['phone'],
                'fund_origin': action.payload['registration']['fund_origin'],
                'fund_type': (action.payload['registration']['fund_type'].charAt(0) + action.payload['registration']['fund_type'].slice(1).toLowerCase()),
                'fund_name': action.payload['application']['fund_name'],
                'jurisdiction': action.payload['application']['jurisdiction'] ? action.payload['application']['jurisdiction'] : undefined,
                'company_name': action.payload['application']['company_name'],
                'abn': action.payload['application']['abn'],
                'acn': action.payload['application']['acn'],
                'agree_terms_and_conditions': action.payload['registration']['agree_terms_and_conditions'],
                'agent_agree_terms_and_conditions': action.payload['registration']['agent_agree_terms_and_conditions']
            }

            let members = action.payload['trustees']

            if (isEmpty(members)) {

                members = [
                    {
                        'first_name': action.payload['member']['first_name'],
                        'last_name': action.payload['member']['last_name'],
                        'email': action.payload['member']['email'],
                        'phone': action.payload['member']['phone'],
                        'not_use_residential_as_mailing': false,
                        'occupationOptions': [],
                    },
                    {
                        'occupationOptions': [],
                    },
                ]
                
            }

            fundData['members'] = members

            // Manage which step of the form user is directed to
            let activeStep = 0
            
            if (action.payload['registration']['agree_terms_and_conditions'] || action.payload['registration']['agent_agree_terms_and_conditions']) {
                activeStep = 4
            }
            else if (action.payload['status']){
                activeStep = 3
            }
    
            return {
                ...state,
                data: fundData,
                activeStep: activeStep,
                fundStatus: action.payload['status']
            }

        case C.CLEAR_FUND_FORM:
            return {
                ...state,
                data: {
                    fund_type: 'Individual',
                    members: [
                        {
                            'not_use_residential_as_mailing': true,
                            'occupationOptions': [],
                        },
                        {
                            'occupationOptions': [],
                        },
                    ]
                },
                activeStep: -1
            }

        case C.SET_FUND_INFO_DATA:

            const fundInfoData = {
                'fund_name': action.payload['fund_name'],
                'fund_type': action.payload['fund_type'],
                'jurisdiction' : action.payload['jurisdiction'] ? action.payload['jurisdiction'] : undefined,
                'account_name': action.payload['investment_details'] ? action.payload['investment_details']['account_name'] : "",
                'account_number': action.payload['investment_details'] ? action.payload['investment_details']['account_number'] : "",
                'bsb': action.payload['investment_details'] ? action.payload['investment_details']['bsb'] : "",
                'abn': action.payload['abn'] ? action.payload['abn'] : 'ABN registration in progress',
                'tfn': action.payload['tfn'],
            }

            const companyDetailsData = {
                'company_name': action.payload['company_details'] ? action.payload['company_details']['company_name'] : '',
                'acn': action.payload['company_details'] ? action.payload['company_details']['acn'] : '',
            }

            return {
                ...state,
                fundInfoData: fundInfoData,
                fundDetailedAssetPosition: [],
                membersTrusteesInfoData: getMemberTrusteeData(action.payload),
                companyDetailsData: companyDetailsData
            }

        case C.SET_BASIC_FUND_INFO_DATA:
            return {
                ...state,
                basicFundInfoData: action.payload
            }

        case C.SET_MEMBERS_TRUSTEES_DATA:
            return {
                ...state,
                membersTrusteesInfoData: getMemberTrusteeData(action.payload)
            }

        case C.SET_COMPANY_DETAILS_DATA:
            const companyDetailsDatax = {
                'company_name': action.payload['company_details'] ? action.payload['company_details']['company_name'] : '',
                'acn': action.payload['company_details'] ? action.payload['company_details']['acn'] : '',
            }
            return {
                ...state,
                companyDetailsData: companyDetailsDatax
            }

        case C.SET_FUND_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }

        case C.SET_FUND_ID:
            return {
                ...state,
                member_id: action.payload.member_id,
                source: action.payload.source
            }

        case C.SET_FUND_POSITION_LOADER:
            return {
                ...state,
                isFundPositionLoading: action.payload
            }

        case C.SET_FUND_POSITION:
            return {
                ...state,
                fundPosition: action.payload
            }

        case C.SET_FUND_ASSET_SUMMARY:
            return {
                ...state,
                fundAssetSummary: action.payload
            }

        case C.SET_FUND_DETAILED_ASSET_POSITION_LOADER:
            return {
                ...state,
                isFundDetailedAssetPositionLoading: action.payload
            }

        case C.SET_FUND_DETAILED_ASSET_POSITION:
            return {
                ...state,
                fundDetailedAssetPosition: action.payload
            }

        case C.SET_FUND_CASH_RECONCILIATION_LOADER:
            return {
                ...state,
                isFundCashReconciliationLoading: action.payload
            }

        case C.SET_FUND_CASH_RECONCILIATION_DATA:
            return {
                ...state,
                fundCashReconciliationData: action.payload
            }

        case C.SET_FUND_CONTRIBUTIONS_LOADER:
            return {
                ...state,
                isFundContributionsLoading: action.payload
            }

        case C.SET_FUND_CONTRIBUTIONS_DATA:
            return {
                ...state,
                fundContributionsData: action.payload
            }

        case C.SET_SUBMITTING_FUND_LOADER:
            return {
                ...state,
                isSubmitting: action.payload
            }

        case C.SET_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload
            }

        default: return state
    }
}


// get the title of the member/truess
function getMemberTrusteeTitle (index, fundData) {
    
    let fundType = fundData['fund_type'] == 'INDIVIDUAL' ? 'Trustee' : 'Director'
    
    switch (index) {
        // Trustee 2 is the special case.
        // When fundData['trustees'] is not empty, meaning the Trustee 2 is not a member
        case 1:
            if (fundData['trustees'].length == 0){
              return `Member & ${fundType} ${index+1}`
            }
            else{
                return `${fundType} ${index+1}`
            }

        default:
            return `Member & ${fundType} ${index+1}`
    }
}

// get refined data of member truste
function getMemberTrusteeData (fundData){
    let allMemberTrustee = fundData['members'].concat(fundData['trustees'])
    const fundMembersTrusteesData = allMemberTrustee.map(
        (ele,index) => {
            return (
                {
                    'heading': getMemberTrusteeTitle(index,fundData),
                    'data': ele
                }
            )
        }
    )

    return fundMembersTrusteesData
}



// WEBPACK FOOTER //
// ./src/reducers/fundReducers.js